export default {"src":"/_next/static/media/contact-our-sales-professionals.1939c5b8.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};